import { render, staticRenderFns } from "./culturelist.vue?vue&type=template&id=5dbedaa0&scoped=true&"
import script from "./culturelist.vue?vue&type=script&lang=js&"
export * from "./culturelist.vue?vue&type=script&lang=js&"
import style0 from "./culturelist.vue?vue&type=style&index=0&id=5dbedaa0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dbedaa0",
  null
  
)

export default component.exports